import { render } from "./ColorPreset.vue?vue&type=template&id=45f5ad06&scoped=true"
import script from "./ColorPreset.vue?vue&type=script&lang=js"
export * from "./ColorPreset.vue?vue&type=script&lang=js"

import "./ColorPreset.vue?vue&type=style&index=0&id=45f5ad06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\houbkar\\WebstormProjects\\PO\\2022-PO-LMO-HTML\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f5ad06"]])

export default __exports__